// Lib
import { get } from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';

// Utils
import { isMobilePage } from '../../mobile/utils/mobileRouteUtils';

// Components
import ModalManager from './ModalManager';

const isNotModal = get(['props', 'route', 'notModal']);

const RouteModalManager = (props) => {
    const { children, routes } = props;

    // The mobile app displays modal contents as a separate navigation page, so don't show them in the modal here
    if (isMobilePage(routes)) return null;

    const component = <ModalManager key={isNotModal(children) ? 'notModal' : 'modal'}>{children}</ModalManager>;

    const transition = !get(['props', 'route', 'noTransition'], children);

    if (!transition) return component;

    return (
        <CSSTransitionGroup
            transitionName="fade-grow"
            transitionAppear
            transitionEnterTimeout={600}
            transitionLeaveTimeout={600}
            transitionAppearTimeout={600}
        >
            {component}
        </CSSTransitionGroup>
    );
};

RouteModalManager.propTypes = {
    children: PropTypes.node,
    routes: PropTypes.array,
};

export default RouteModalManager;
